import { Injectable, inject } from "@angular/core";

import { AdviceDoc } from "@aa/common";
import { SelfServMetaCacheService } from "./selfserv-meta-cache.service";

@Injectable({ providedIn: "root" })
export class ShareService {
  private readonly metaCache = inject(SelfServMetaCacheService);

  public readonly canShare: boolean;

  constructor() {
    this.canShare = !!navigator.share;
  }

  // called by app initializer in core module
  public share(doc: AdviceDoc): void {
    const meta = this.metaCache.meta;

    if (!this.canShare || !meta) {
      console.warn("share unavailable");
      return;
    }

    navigator
      .share({
        title: `Housing Advice: ${doc.name}`,
        url: `${meta.url}advice/${doc.slug}`,
      })
      .then(() => console.log("Successful share"))
      .catch((error) => console.log("Error sharing", error));
  }
}
